var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrapper position-relative mb-4"},[_c('div',{staticClass:"placeholder timeline"})]),_c('div',{staticClass:"wrapper position-relative mb-4"},[_c('div',{staticClass:"placeholder breakdown"})]),_c('div',{staticClass:"wrapper position-relative mb-4"},[_c('div',{staticClass:"placeholder table"})])])
}]

export { render, staticRenderFns }